import classes from "./MainProductReview.module.scss";
import ReviewStarsWithCounter from '@/components/Review/ReviewStarsWithCounter/ReviewStarsWithCounter'
import { useState, useEffect } from 'react'

const MainProductReview = ({ productReviews, reviewsRef }) => {
  const [isReviewExpanded, setIsReviewExpanded] = useState(false); // New state

  // Check if URL hash is "#reviews" and expand if so
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash === '#reviews') {
      setIsReviewExpanded(true);
    }
  }, []);


  const handleLinkClick = (e) => {
    console.log('click')

    e.preventDefault(); // Prevent default anchor behavior
    setIsReviewExpanded(true); // Expand the review section

    // Set the URL hash for direct linking
    if (typeof window !== 'undefined') {
      window.location.hash = '#reviews';  // Or you could use a more sophisticated routing library here if available
    }

    setTimeout(() => {
      console.log('reviewsRef');
      console.log(reviewsRef);
      if (reviewsRef.current) {  // Check if the ref is attached
        reviewsRef.current.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll
      }
    }, 0); // Or adjust delay if needed
  };

  return (
    <div className={classes['product-review-container']}>
      <ReviewStarsWithCounter
        numberOfReviews={productReviews.totalReviews}
        rating={productReviews.average}
        maxWidth={100}
      />
      <a
          href="#reviews"
          className={classes['product-hero__review-link']}
          onClick={handleLinkClick}
        >
        Read Reviews
      </a>
    </div>
  );
};

export default MainProductReview;